var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var gipMerchantAccountExtService = require('./../../../../urls').gipMerchantAccountExtService;

/**
 * A Model representing a GipMerchantAccount
 * @class GipMerchantAccountModel
 * @extends TorsoNestedModel
 */
module.exports = TorsoNestedModel.extend({
    idAttribute: 'vecnaId',
    urlRoot: gipMerchantAccountExtService,
    defaults: {
        active: true,
        defaultAccount: true
    }
});
